import { render } from "./ThePostTemplate.vue?vue&type=template&id=550e7b7e&scoped=true&ts=true"
import script from "./ThePostTemplate.vue?vue&type=script&lang=ts"
export * from "./ThePostTemplate.vue?vue&type=script&lang=ts"

import "./ThePostTemplate.vue?vue&type=style&index=0&id=550e7b7e&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550e7b7e"]])

export default __exports__